export const AUDIO_PLAYER = 'cap_audio';
